export default "__VITE_ASSET__CICnH9pk__"